import { render, staticRenderFns } from "./show-more-btn.vue?vue&type=template&id=25d9fbac&scoped=true&"
import script from "./show-more-btn.vue?vue&type=script&lang=js&"
export * from "./show-more-btn.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "25d9fbac",
  null
  ,true
)

export default component.exports